import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import StrUtils from '@/utils/StrUtils'
import { unJointSlavesHblOrMbl } from '@/api/SeaImport/seaImportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { sortByMultiFieldAndOrder } from '@/utils'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { getLoading } from '@/utils/utilBaseElement'

export class TabMBL2PM extends AbstractViewManage {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
    this.addrPM = null
    this._mblCargoDoc = null
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    // 不可赋值
  }
  get paymentTermList() {
    return this.view.context.paymentTermList
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.addrPM = new BillAddressCommonPM(this.view)
    this.view.addrPM.job = this.job
    this.view.form = form
  }
  init() {
    for (const item of this.context.blModeList) {
      if (item.blType === BlModeType.MBL2.code) {
        this.view.blModeList.push(item)
      }
    }
    this.view.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars')) || 45
  }
  async display() {
    const job = new SeaImportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    this.loadJointSlaves2Handler(jointSlavesMBL)
  }
  async changeJob() {
    this.view.warningCount = -1
    const cmp = this.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (cmp) {
      await new Company(cmp).getShipping()
      this.loadShippingResult(cmp)
    }
  }
  fillView() {
    this.refreshQuantitySum()
  }
  fillModel() {
    if (this.form.mblNbr2) {
      for (const item of this.view.splitOrder.rowData) {
        if (this.form !== item && this.form.mblNbr2 === item.mblNbr2) {
          this.$message.warning(this.view.$t('Message.MBLNOCannotBeDuplicated'))
        }
      }
    }
    this.form.shipperLine7 = this.form.shipperLine7 || ''
    this.form.consigneeLine7 = this.form.consigneeLine7 || ''
    this.form.notifyLine7 = this.form.notifyLine7 || ''

    // 提单发货地
    // this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    this.form = new SeaImCargoDoc(this.form).fillDefaultValue().getData() // 填充默认值 -
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    // this.form.destinationPlace = this.form.destinationPlace.toUpperCase()

    // 开航日期
    // MBL付款方式
    this.form.paymentTerm = this.form.paymentTerm.toUpperCase()
    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()
    // 英文品名
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // 签发地点
    this.form.signPlaceBL = this.form.signPlaceBL.toUpperCase()
    // 唛头
    // this.form.mark = this.form.mark.toUpperCase()

    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()

    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    this.form.seaeq = this.form.seaeq.toUpperCase()
    this.form.container = this.form.container.toUpperCase()
  }
  validateForm() {
    let _t_quantity = 0
    let _t_weight = 0
    let _t_cubage = 0
    if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
      // MBL拆单,子单件毛体总和
      for (const doc1 of this.view.splitOrder.rowData) {
        if (doc1.docType === CargoDocConsts.MBL2) {
          // 件数
          _t_quantity += Number(doc1.quantity)
          // 重量
          _t_weight += Number(doc1.weight)
          // 体积
          _t_cubage += Number(doc1.cubage)
        }
      }
      if ((_t_quantity !== 0 && _t_quantity !== Number(this.job.quantityActual)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.job.weightActual).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.job.cubageActual).toFixed(3))) {
        this.$message.warning(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    } else if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      for (const doc2 of this.job.seaCargoDoc) {
        // 当前订单MBL件毛体
        if (doc2.docType === CargoDocConsts.MBL) {
          // 件数
          _t_quantity += Number(doc2.quantity)
          // 重量
          _t_weight += Number(doc2.weight)
          // 体积
          _t_cubage += Number(doc2.cubage)
          break
        }
      }
      // 并单件毛体
      for (const job of this.job.jointSlavesMBL) {
        _t_quantity += Number(job.quantityActual)
        // 重量
        _t_weight += Number(job.weightActual)
        // 体积
        _t_cubage += Number(job.cubageActual)
      }
      if (this.form.quantity && this.form.weight && this.form.cubage && ((_t_quantity !== 0 && _t_quantity !== Number(this.form.quantity)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.form.weight).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.form.cubage).toFixed(3)))) {
        this.$message.warning(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    }
    return true
  }
  print() {
    // if (null == view.cargoDoc) {
    //   this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   return
    // }
    // var params = new Object()
    // if (view.job.typeMBL == BillType.SPLIT_BILL_TYPE.code) {
    //   if (view.gdMBL2.selectedItem) {
    //     params.jobuuid = view.job.key
    //     params.cargoDocUuid = view.cargoDoc.key
    //     params.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, "MBL2", params, view)
    //   }
    //   else {
    //     this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   }
    // }
    // else if (view.job.typeMBL == BillType.MERGE_BILL_TYPE.code) {
    //   if (view.cargoDoc) {
    //     params.jobuuid = view.job.key
    //     params.cargoDocUuid = this.view.cargoDoc.key
    //     params.DOC_UUID = this.view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, "MBL2", params, view)
    //   }
    // }
  }
  /**
   * save task
   */
  executeTask() {
    DocCommon.MBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.MBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.MBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.MBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.MBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.MBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.MBL_History.shipperCode = this.form.shipperCode
    DocCommon.MBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.MBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.MBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.MBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.MBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.MBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.MBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.MBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.MBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.MBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.MBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.MBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.MBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.MBL_History.notifyCode = this.form.notifyCode
    DocCommon.MBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.MBL_History.mark = this.form.mark
    this.view.addJoinMergeJobList = []
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
  }
  async loadCargoDoc2Handler(cargoDocList) {
    const cargoDocs = []
    if (cargoDocList.length > 0) {
      for (const item of cargoDocList) {
        if (item.docType === CargoDocConsts.MBL) {
          this._mblCargoDoc = item
        } else if (item.docType === CargoDocConsts.MBL2) {
          cargoDocs.push(item)
        }
      }
      this.view.splitOrder.rowData = sortByMultiFieldAndOrder(cargoDocs, { mblNbr2: 'asc', hblNbr2: 'asc' })
    }
    if (cargoDocs.length > 0) {
      this.form = cargoDocs[0]
    } else {
      if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
        await this.onAddSplitDocEvent()
      }
    }
    if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.form.hblNbr2 = this.job.jobNo
    }
    if (!this.form.paymentTerm) {
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''
    }
    await this.showScac()
    this.showDocState()
    this.view.$nextTick(() => { // 选中新增项
      if (this.view.splitOrder.gridOptions.api) {
        const nodes = this.view.splitOrder.gridOptions.api.getRenderedNodes()
        if (nodes.length > 0) {
          nodes[0].setSelected(true)
        }
      }
    })
  }
  loadJointSlaves2Handler(jointSlavesMBL) {
    this.view.mergeOrder.rowData = jointSlavesMBL
  }
  loadShippingResult(cmp) {
    if (cmp && cmp.shipping) {
      for (const item of cmp.shipping) {
        if (item.branchId === this.job.opOffice) {
          this.view.warningCount = 35
          return
        }
      }
    }
  }
  /**
   *  提单方式
   */
  cmbreleaseTypeMBLChangeHandler(value) {
    this.form.blNumber = Number(value) === 1 ? 'THREE' : 'ONE'
  }
  onCopy1() {
    this.form.shipperCode = DocCommon.MBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.MBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.MBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.MBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.MBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.MBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.MBL_History.shipperLine6 || ''

    this.form.consigneeCode = DocCommon.MBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.MBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.MBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.MBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.MBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.MBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.MBL_History.consigneeLine6 || ''

    this.form.notifyCode = DocCommon.MBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.MBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.MBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.MBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.MBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.MBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.MBL_History.notifyLine6 || ''

    this.form.cargoEnglishName = DocCommon.MBL_History.englishCargoName || ''
    this.form.mark = DocCommon.MBL_History.mark || ''
  }
  selectionItemHandler(rows) {
    const selectedMBL = rows[0]
    if (selectedMBL && Object.keys(selectedMBL).length > 0) {
      this.form.shipperCode = selectedMBL.shipperCode
      this.form.shipperLine1 = selectedMBL.shipperLine1
      this.form.shipperLine2 = selectedMBL.shipperLine2
      this.form.shipperLine3 = selectedMBL.shipperLine3
      this.form.shipperLine4 = selectedMBL.shipperLine4
      this.form.shipperLine5 = selectedMBL.shipperLine5
      this.form.shipperLine6 = selectedMBL.shipperLine6
      this.form.consigneeCode = selectedMBL.consigneeCode
      this.form.consigneeLine1 = selectedMBL.consigneeLine1
      this.form.consigneeLine2 = selectedMBL.consigneeLine2
      this.form.consigneeLine3 = selectedMBL.consigneeLine3
      this.form.consigneeLine4 = selectedMBL.consigneeLine4
      this.form.consigneeLine5 = selectedMBL.consigneeLine5
      this.form.consigneeLine6 = selectedMBL.consigneeLine6
      this.form.notifyCode = selectedMBL.notifyCode
      this.form.notifyLine1 = selectedMBL.notifyLine1
      this.form.notifyLine2 = selectedMBL.notifyLine2
      this.form.notifyLine3 = selectedMBL.notifyLine3
      this.form.notifyLine4 = selectedMBL.notifyLine4
      this.form.notifyLine5 = selectedMBL.notifyLine5
      this.form.notifyLine6 = selectedMBL.notifyLine6
      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }
  /**
   * 抄录收货人
   */
  onCopyConsignee() {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  /**
   * 添加拆单
   */
  async onAddSplitDocEvent() {
    this.fillModel()
    this.form = new SeaImCargoDoc().fillDefaultValue().getData()
    await SeaImCargoDoc.copyInfoFromSeaImportJob(this.job, this.form)
    this.form.docType = CargoDocConsts.MBL2
    if (this._mblCargoDoc) {
      this.form.shipperLine1 = this._mblCargoDoc.shipperLine1
      this.form.shipperLine2 = this._mblCargoDoc.shipperLine2
      this.form.shipperLine3 = this._mblCargoDoc.shipperLine3
      this.form.shipperLine4 = this._mblCargoDoc.shipperLine4
      this.form.shipperLine5 = this._mblCargoDoc.shipperLine5
      this.form.shipperLine6 = this._mblCargoDoc.shipperLine6
      this.form.shipperLine7 = this._mblCargoDoc.shipperLine7
      this.form.shipperCode = this._mblCargoDoc.shipperCode

      this.form.consigneeLine1 = this._mblCargoDoc.consigneeLine1
      this.form.consigneeLine2 = this._mblCargoDoc.consigneeLine2
      this.form.consigneeLine3 = this._mblCargoDoc.consigneeLine3
      this.form.consigneeLine4 = this._mblCargoDoc.consigneeLine4
      this.form.consigneeLine5 = this._mblCargoDoc.consigneeLine5
      this.form.consigneeLine6 = this._mblCargoDoc.consigneeLine6
      this.form.consigneeLine7 = this._mblCargoDoc.consigneeLine7
      this.form.consigneeCode = this._mblCargoDoc.consigneeCode

      this.form.notifyLine1 = this._mblCargoDoc.notifyLine1
      this.form.notifyLine2 = this._mblCargoDoc.notifyLine2
      this.form.notifyLine3 = this._mblCargoDoc.notifyLine3
      this.form.notifyLine4 = this._mblCargoDoc.notifyLine4
      this.form.notifyLine5 = this._mblCargoDoc.notifyLine5
      this.form.notifyLine6 = this._mblCargoDoc.notifyLine6
      this.form.notifyLine7 = this._mblCargoDoc.notifyLine7
      this.form.notifyCode = this._mblCargoDoc.notifyCode

      this.form.BLNumber = this._mblCargoDoc.BLNumber
      this.form.paymentPlaceBL = this._mblCargoDoc.paymentPlaceBL
      this.form.quantity = this.job.quantityActual
      this.form.weight = this.job.weightActual
      this.form.cubage = this.job.cubageActual
      this.form.chargeWeight = this.job.chargeWeight
      this.form.signPlaceBL = this._mblCargoDoc.signPlaceBL
      this.form.signDateBL = this._mblCargoDoc.signDateBL

      // 包装
      this.form.packing = this.job.packing
      this.form.cargoEnglishName = this._mblCargoDoc.cargoEnglishName
      this.form.alsoNotify = this._mblCargoDoc.alsoNotify
      this.form.mark = this._mblCargoDoc.mark

      this.form.releaseType = this._mblCargoDoc.releaseType
      // 付款方式
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''

      const _hCargoDoc = this.job.seaCargoDoc
      for (const item of _hCargoDoc) {
        if (item.docType === CargoDocConsts.MBL2) {
          // 件数
          this.form.quantity = this.form.quantity - item.quantity
          // 重量
          this.form.weight = this.form.weight - item.weight
          // 体积
          this.form.cubage = this.form.cubage - item.cubage
        }
      }
      if (isNaN(this.form.weight)) {
        this.form.weight = 0
      }
      if (isNaN(this.form.cubage)) {
        this.form.cubage = 0
      }
    }
    if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.form.hblNbr2 = this.job.jobNo
      this.form.mblNbr2 = this.job.mbl
    } else {
      this.form.hblNbr2 = this.job.jobNo + '-' + (this.view.splitOrder.rowData.length + 1)
    }
    this.form.state = 1
    this.form.jobUuid = this.job.uuid
    if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code || this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.view.splitOrder.rowData.push(this.form)
      this.job.seaCargoDoc.push(this.form)
      this.view.$nextTick(() => {
        const nodes = this.view.splitOrder.gridApi.getRenderedNodes()
        nodes[nodes.length - 1].setSelected(true)
      })
    }
    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
  }
  /**
   * 移除拆单
   */
  onRemoveSliptDocEvent() {
    const rows = this.view.splitOrder.gridApi.getSelectedRows()
    if (rows.length > 0) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + rows[0].hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.onRemoveConfirmed(rows[0])
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('Message.PleaseSelectMBLNo'))
    }
  }
  onRemoveConfirmed(row) {
    if (row.uuid) {
      row.deleted = true
      const tempRowData = this.view.splitOrder.rowData
      this.view.splitOrder.rowData = []
      this.view.$nextTick(() => {
        this.view.splitOrder.rowData = tempRowData
      })
      const cargoDoc = this.job.seaCargoDoc.find(p => p.uuid === row.uuid)
      if (cargoDoc) cargoDoc.deleted = true
    } else {
      const index = this.view.splitOrder.rowData.findIndex(p => p === row)
      if (index >= 0) {
        this.view.splitOrder.rowData.splice(index, 1)
      }
      const cargoDocIndex = this.job.seaCargoDoc.findIndex(p => p === row)
      if (cargoDocIndex >= 0) {
        this.job.seaCargoDoc.splice(cargoDocIndex, 1)
      }
    }
    // 不存到数据库
    this.form = new SeaImCargoDoc().fillDefaultValue().getData()
    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
    this.view.$nextTick(() => { // 选中新增项
      const nodes = this.view.splitOrder.gridApi.getRenderedNodes()
      if (nodes.length > 0) {
        nodes[0].setSelected(true)
      }
    })
  }

  /**
   * select job 拆单
   */
  onSelectionChange(event) {
    if (!event.data) {
      return
    }
    this.fillModel()
    this.form = event.data
    this.refreshQuantitySum()
    this.printStateChange()
  }
  /**
   * 添加并单
   */
  onJobsAdd() {
    Object.assign(this.view.searchBillNoDialog.params, {
      selectType: 'multiple',
      docType: CargoDocConsts.MBL2,
      job: this.job,
      useDefaultCondition: true
    })
    this.view.searchBillNoDialog.selectHandler = p => { this.selectionItemsHandler(p) }
    this.view.searchBillNoDialog.visible = true
  }
  selectionItemsHandler(selectedJobs) {
    const rowData = this.view.mergeOrder.rowData
    const jobKeySet = {}
    for (const seaJob of rowData) {
      jobKeySet[seaJob.uuid] = true
    }
    for (const sJob of selectedJobs) {
      if (!jobKeySet[sJob.uuid]) {
        rowData.push(sJob)
        this.view.addJoinMergeJobList.push({ masterJobUuid: this.job.uuid, key: sJob.uuid, version: sJob.version, type: 'MBL' })
      }
    }
    SeaExportUtils.jointJobsMBL(this.job, this.form, selectedJobs)
    this.refreshQuantitySum()
    const obj = SeaExportUtils.jointSeqContainerInfo(this.form.seaeq, this.form.container, this.job, this.form, selectedJobs, Number(this.form.chargeWeight))
    this.form.cargoEnglishName = obj.cargoEnglishName
    this.form.chargeWeight = obj.chargeWeight
    for (const item of selectedJobs) {
      item.todo = 'new'
    }
  }
  /**
   * 移除并单
   */
  onJobsRemove() {
    const doc = this.view.mergeOrder.gridApi.getSelectedRows()[0]
    if (doc) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + doc.jobNo + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.on_jobsRemoveConfirmed(doc)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('SeaExport.SelectARecord'))
      return
    }
  }
  on_jobsRemoveConfirmed(job) {
    // 先保留原始的值，如果调用后端请求失败，则还原这几个字段
    const oldCargoDoc = {
      quantity: this.form.quantity,
      weight: this.form.weight,
      cubage: this.form.cubage,
      chargeWeight: this.form.chargeWeight
    }
    // 件数
    const quantity = this.form.quantity - job.quantityActual
    // 重量
    const weight = this.form.weight - job.weightActual
    // 体积
    const cubage = this.form.cubage - job.cubageActual
    // 计费重量
    const chargeWeight = this.form.cubage - job.chargeWeight

    // 如果提单是已经真是存在的,此时立即调用移除并单操作，并且已经真实并入的才能调用后台
    if (this.form.uuid && job && job.jointMasterMBLUuid && job.joinFlagMBL) {
      const param = {}
      param.docType = 'MBL2'
      param.job = { key: this.job.uuid, version: this.job.version }
      param.unJob = { key: job.uuid, version: job.version }
      param.cargoDoc = {
        key: this.form.uuid,
        version: this.form.version,
        quantity: isNaN(quantity) ? 0 : Number(quantity),
        weight: isNaN(weight) ? 0 : Number(weight),
        cubage: isNaN(cubage) ? 0 : Number(cubage),
        chargeWeight: isNaN(this.form.chargeWeight) ? 0 : Number(this.form.chargeWeight)
      }
      unJointSlavesHblOrMbl(param).then(res => {
        if (res.data) { // 由于是编辑状态下,所以删除操作成功以后要更新对应的字段以及版本号
          const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            this.view.mergeOrder.rowData.splice(index, 1)
          }
          if (res.data.job) {
            this.job.version = res.data.job.version
            this.job.joinFlagMBL = res.data.job.joinFlagMBL
            this.job.jointMasterMBLUuid = res.data.job.jointMasterMBLUuid
            this.view.$emit('syncData', {
              jointMasterMBLUuid: this.job.jointMasterMBLUuid,
              joinFlagMBL: this.job.joinFlagMBL,
              version: this.job.version
            })
          }
          if (res.data.cargoDoc) {
            this.form.version = res.data.cargoDoc.version
            this.form.quantity = res.data.cargoDoc.quantity
            this.form.weight = res.data.cargoDoc.weight
            this.form.cubage = res.data.cargoDoc.cubage
            this.form.chargeWeight = res.data.cargoDoc.chargeWeight
            this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
          }
          this.view.$emit('syncData', { jointSlavesMBL: '', isCompleteRow: false })
        }
      }).catch(() => {
        this.form.quantity = oldCargoDoc.quantity
        this.form.weight = oldCargoDoc.weight
        this.form.cubage = oldCargoDoc.cubage
        this.form.chargeWeight = oldCargoDoc.chargeWeight
      })
    } else {
      // 移除addJoinMergeJobList中的数据
      const addJoinMergeJobList = this.view.addJoinMergeJobList
      if (addJoinMergeJobList && addJoinMergeJobList.length > 0) {
        for (let i = 0; i < addJoinMergeJobList.length; i++) {
          if (addJoinMergeJobList[i].key === job.uuid) {
            addJoinMergeJobList.splice(i, 1)
            break
          }
        }
      }

      const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
      if (index >= 0) {
        this.view.mergeOrder.rowData.splice(index, 1)
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      this.form.chargeWeight = chargeWeight
    }
  }
  packing_Change(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()
  }
  quantity_Change(value) {
    this.form.quantity = value
    this.refreshQuantitySum()
  }
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      default:
        break
    }
  }
  getPaymentTermNameByCode(code) {
    if (!code) {
      return ''
    }
    const paymentTerm = this.paymentTermList.find(p => p.code === code)
    if (paymentTerm) {
      return paymentTerm.name
    }
    return code
  }
  printStateChange() {
    // view.enablePrint = (view.job.typeMBL == BillType.MERGE_BILL_TYPE.code || view.gdMBL2.selectedItem != null)
  }
  /**
   * refresh
   */
  refreshSeqContainer() {
    // view.txtseaeq.text = SeaExportUtils.getJoinSeaDocSeaEQDesc(view.cargoDoc, view.job, view.printParam1.selected, view.printParam1.label)
    // view.txtcontainer.text = SeaExportUtils.getContainerQWCDesc(view.cargoDoc, view.printParam3.selected)
  }
  /**
   * 取回(撤销取回)和放单(撤销放单)
   */
  async btnGetBackClickHandler() {
    this.view.loading = getLoading()
    if (this.form.uuid) {
      let params = null
      if (Number(this.form.bliStatus) === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code) {
        // 撤销取回
        params = {
          bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code,
          getBackDate: '',
          operation: CargoDocCfmState.CARGODOC_CANCEL_GET_BACK
          // isCancel: true // CARGO-31462 取回和撤销取回状态不对，经后端查验，该参数相关逻辑有误，删除后功能正常
        }
      } else {
        // 取回
        params = {
          bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code,
          getBackDate: new Date(),
          operation: CargoDocCfmState.CARGODOC_GET_BACK
        }
      }
      const seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], params)
      if (seaCargoDoc && seaCargoDoc.length > 0) {
        Object.assign(this.form, seaCargoDoc[0])
      }
      await this.saveReleaseStateStateHandler()
      this.view.loading.close()
    }
  }
  async btnReleasingClickHandler() {
    if (this.form.uuid && this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code) {
      // 撤销放单
      const obj = {}
      obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
      obj.releaseDate = ''
      obj.operation = CargoDocCfmState.CARGODOC_CANCEL_RETURN
      obj.surrenderedNo = ''
      obj.releaseState = CargoDocCfmState.CARGODOC_CAN_SINGLE_RELEASE
      obj.releaseBy = 0
      this.job.seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], obj)
      await this.saveReleaseStateStateHandler()
    } else if (this.form.uuid && this.form.releaseState === ReleaseState.SINGLERELEASE.code) {
      // 放单
      this.view.$prompt('放单号:', this.view.$t('SeaExport.EnterReleaseNumber'), {
        confirmButtonText: this.view.$t('Invoice.invoice_confirm'),
        cancelButtonText: this.view.$t('Message.Cancel')
      }).then(async value => {
        await this.commitSurrenderedNoHandler(value)
      }).catch(() => { })
    }
  }
  async commitSurrenderedNoHandler(value) {
    const obj = {}
    obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
    obj.releaseDate = new Date()
    obj.operation = CargoDocCfmState.CARGODOC_RETURN
    obj.surrenderedNo = value
    this.job.seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], obj)
    await this.saveReleaseStateStateHandler()
  }
  async saveReleaseStateStateHandler(e) {
    this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    this.job.seaCargoDoc = ''
    await new SeaImportJob(this.job).getSeaCargoDoc()
    await this.loadCargoDoc2Handler(this.job.seaCargoDoc)
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  showDocState() {
    const isZh = this.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  refreshSeaeqNumber() {
    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)
  }
}
